import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';

/**
 * Wraps a component and gives it the ability to handle clicks on any element,
 * including itself and it's children.
 */
export default function makeBodyClick() {
  var method = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'onBodyClick';
  function decorator(Component) {
    var newName = "Wrapped".concat(Component.name || Component.displayName);
    var Wrapped = /*#__PURE__*/function (_React$Component) {
      function Wrapped() {
        var _this;
        _classCallCheck(this, Wrapped);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _callSuper(this, Wrapped, [].concat(args));
        _this.handleClick = function (e) {
          _this.__wrappedComponent[method](e);
        };
        return _this;
      }
      _inherits(Wrapped, _React$Component);
      return _createClass(Wrapped, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          document.addEventListener('click', this.handleClick, true);
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          document.removeEventListener('click', this.handleClick, true);
        }
      }, {
        key: "render",
        value: function render() {
          var _this2 = this;
          return /*#__PURE__*/React.createElement(Component, _extends({}, this.props, {
            ref: function ref(x) {
              _this2.__wrappedComponent = x;
            }
          }));
        }
      }]);
    }(React.Component);
    Wrapped.displayName = newName;
    return Wrapped;
  }
  return decorator;
}
//# sourceMappingURL=bodyClick.js.map
